import {
  Box,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";

const formatDate = (value) => {
  if (!value) return "—";
  return dayjs(value).format("DD MMM YYYY, HH:mm");
};

const COLUMNS = [
  { label: "Site ID", key: "site_id", render: (row) => row.site_id || "—" },
  { label: "Subject ID", key: "participant_id", render: (row) => row.participant_id || "—" },
  { label: "Trial Name", key: "trial_name", render: (row) => row.trial_name || "—" },
  { label: "Visit Name", key: "visit_name", render: (row) => row.visit_name || "—" },
  { label: "Subject Email", key: "subject_email", render: (row) => row.subject_email || "—" },
  {
    label: "Subject First Name",
    key: "subject_first_name",
    render: (row) => row.subject_first_name || "—",
  },
  {
    label: "Subject Last Name",
    key: "subject_last_name",
    render: (row) => row.subject_last_name || "—",
  },
  { label: "Updater Email", key: "updater_email", render: (row) => row.updater_email || "—" },
  {
    label: "Updater First Name",
    key: "updater_first_name",
    render: (row) => row.updater_first_name || "—",
  },
  {
    label: "Updater Last Name",
    key: "updater_last_name",
    render: (row) => row.updater_last_name || "—",
  },
  { label: "Updater Role", key: "updater_role", render: (row) => row.updater_role || "—" },
  { label: "Date/Time", key: "action_datetime", render: (row) => formatDate(row.action_datetime) },
  {
    label: "Visit Open Date",
    key: "visit_open_date",
    render: (row) => formatDate(row.visit_open_date),
  },
  {
    label: "Visit Close Date",
    key: "visit_close_date",
    render: (row) => formatDate(row.visit_close_date),
  },
  {
    label: "In-Clinic Visit Open Date",
    key: "inclinic_visit_open_date",
    render: (row) => formatDate(row.inclinic_visit_open_date),
  },
  {
    label: "In-Clinic Visit End Date",
    key: "inclinic_visit_end_date",
    render: (row) => formatDate(row.inclinic_visit_end_date),
  },
  {
    label: "In-Clinic Visit Status",
    key: "inclinic_visit_status",
    render: (row) => row.inclinic_visit_status || "—",
  },
  {
    label: "App Visit Status",
    key: "inapp_visit_status",
    render: (row) => row.inapp_visit_status || "—",
  },
  { label: "Subject Status", key: "subject_status", render: (row) => row.subject_status || "—" },
];

const VisitConfigLogTable = ({ logs, currentPage, onPageChange }) => {
  const rows = logs?.results ?? [];
  const totalPages = logs?.count ? Math.ceil(logs.count / 10) : 0;

  if (!rows.length) {
    return (
      <Box py={6} display="flex" justifyContent="center">
        <Typography color="text.secondary">No visit config logs found.</Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={2}>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small" sx={{ minWidth: 900 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              {COLUMNS.map((col) => (
                <TableCell key={col.key} sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id} hover>
                {COLUMNS.map((col) => (
                  <TableCell key={col.key} sx={{ whiteSpace: "nowrap" }}>
                    {col.render(row)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {totalPages > 1 && (
        <Box display="flex" justifyContent="center">
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(_, page) => onPageChange(page)}
            color="primary"
            shape="rounded"
          />
        </Box>
      )}
    </Stack>
  );
};

export default VisitConfigLogTable;
